var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"5"}},[_c('v-dialog',{attrs:{"max-width":"500px","persistent":"","transition":"dialog-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('card-loading',{attrs:{"loadingText":_vm.loadingText,"color":_vm.color}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }